import AmexPlatinumNightsBenefitsCard from './AmexPlatinumNightsBenefitsCard';

export default AmexPlatinumNightsBenefitsCard;
